import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { tenantStoreSelector } from '../tenant.selector';

export const selectedTenantSelector = createCachedSelector(
  [
    path(tenantStoreSelector).selected(),
  ],
  (selected) => selected,
)({
  keySelector: defaultKeySelector,
});
